import { type NativeMessenger } from './native-messenger'
import { type NativeRequestPayload } from './native-request'

export const iosAdapter: NativeMessenger = {
  isAvailable: () => {
    return !!window?.webkit?.messageHandlers?.iosListener?.postMessage
  },
  send: (payload: NativeRequestPayload) => {
    const msg = JSON.stringify(payload)
    window?.webkit?.messageHandlers?.iosListener?.postMessage(msg)
  }
}
